// removed by extract-text-webpack-plugin
module.exports = {"component":"_1s24qvtQ3UjTki8eKHevGn","active":"JSeBPxXxQucOFbF7qhuhA","initials":"_1HIL4DVdq0muJSKMn23PuK","info":"_11AT4UMMaLlIHYe-vfnAIW","button":"_2Jn3lwCeTF98aWUPBqK4e3","checkmark":"_3f1zzqz8-Dl_bEwDTlmVKs","flex":"_23y0w18oh7Lvbcbs600i1o","static":"_2C1zXG7VQMSkGbGufuS1OH","primaryText":"_uGtt5oum_VXxyx-Ngh98","secondaryText":"_1rqK_7QybDFNppGHH4VluL","dialog":"_2niCqrRrevSnfs_KNK-c58","dialogTitle":"_2zQNY7SwQvS6uTjy8-R1xi","dialogCta":"yzQUKC2pwUdbJQ9Y_JCyK","dialogErrorCta":"_3tjfcPZhDvLIbY7iktlPS8","dialogErrorLink":"_2Ie0CMNYwe-MNJJ-n0Un5O"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Family/FamilyMemberItem/FamilyMemberItem.css
// module id = 1294
// module chunks = 0